export default __webpack_public_path__ + "79da213423ac0def2058ceb081a09a96.ttf";